import { render, staticRenderFns } from "./PreScreenedTable.vue?vue&type=template&id=10c25328&scoped=true&"
import script from "./PreScreenedTable.vue?vue&type=script&lang=js&"
export * from "./PreScreenedTable.vue?vue&type=script&lang=js&"
import style0 from "./PreScreenedTable.vue?vue&type=style&index=0&id=10c25328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c25328",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
